import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Fetcher } from '../../Fetcher';

import type { StatsSettingsType } from './types';

export interface FetchStatsSettingsParams {
  url: string;
}

export const fetchStatsSettings = ({ url }: FetchStatsSettingsParams): Promise<StatsSettingsType> => {
  return Fetcher.fetch<StatsSettingsType>(url + '/eventcapture/settings').then<StatsSettingsType>((result) => {
    ApiBitMask.apply(ApiBitMaskTypes.StatsSettings);
    return result;
  });
};
